import React from 'react'
import { Redirect } from 'react-router-dom'
import { createMuiTheme, makeStyles, MuiThemeProvider } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container'
import CssBaseline from '@material-ui/core/CssBaseline'

import HomeCard from '../../components/HomeCard'
import { createCampaign, getCampaigns } from '../../api/user'
import { useError } from '../../utils'
import CampaignForm from './CampaignForm'

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontSize: 14,
  },
  submit: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    width: '100%',
    fontSize: 16
  },
}))

const Home = () => {
  const classes = useStyles()

  const [ campaignName, setCampaignName ] = React.useState('')
  const [ existingCampaigns, setExistingCampaigns ] = React.useState([])
  // the selected ID from an existing campaign
  const [ selectedCampaign, setSelectedCampaign ] = React.useState('')
  const [ shouldRedirect, setShouldRedirect ] = React.useState(false)
  const { error, setError } = useError()

  React.useEffect(() => {
    getCampaigns().then((campaigns) => {
      setExistingCampaigns(campaigns)
    })
  }, [])

  const onSubmit = async () => {
    try {
      if (campaignName.length > 0) {
        const campaignRef = await createCampaign(campaignName)
        setShouldRedirect(campaignRef.id)
      } else if (selectedCampaign) {
        setShouldRedirect(selectedCampaign)
      }else {
        setError({ message: 'Please select a campaign, or enter a campaign name' })
      }
    } catch(e) {
      setError(e)
    }
  }

  if (shouldRedirect) return <Redirect to={`/campaign/${shouldRedirect}`} />

  return (
    <Container component='main' maxWidth='xs'>
      <div className={classes.paper}>
        <HomeCard
          title='1. Select a Campaign'
          subTitle='Choose an existing campaign, or create a new one for you and your group:'
        >
          <CampaignForm
            existingCampaigns={existingCampaigns}
            campaignName={campaignName}
            setCampaignName={setCampaignName}
            selectedCampaign={selectedCampaign}
            setSelectedCampaign={setSelectedCampaign} />
        </HomeCard>
        {error}
        <Button
          disabled={!campaignName && !selectedCampaign}
          type='button'
          variant='contained'
          color='primary'
          className={classes.submit}
          onClick={onSubmit}
        >
          2. Let&apos;s roll!
        </Button>
      </div>
    </Container>
  )
}

export default Home
